// extracted by mini-css-extract-plugin
export var divider = "PaymentForm-module__divider___fuBaK";
export var button = "PaymentForm-module__button___tDqTG";
export var form = "PaymentForm-module__form___DaKhm";
export var fine = "PaymentForm-module__fine___aq5t7";
export var error = "PaymentForm-module__error___ryuSb";
export var grid = "PaymentForm-module__grid___WUa3x";